import { useState } from 'react'
import { useContacts } from '@/hooks/useApi'
import { useDebounce } from '@/hooks/useDebounce'

const SEGMENT_CONTACTS_PAGE_SIZE = 50
const SEGMENT_CONTACTS_SEARCH_DEBOUNCE_MS = 300

/** Elenco dei contatti di un segmento, paginato e cercato lato server (#380). */
export function useSegmentContactSearch(segmentId: string, enabled: boolean) {
  const [searchInput, setSearchInput] = useState('')
  const search = useDebounce(searchInput, SEGMENT_CONTACTS_SEARCH_DEBOUNCE_MS).trim()
  // Ogni cambio del testo azzera la pagina salvata, anche se il testo torna a
  // un valore precedente. Si azzera durante il render, non in un effetto, così
  // nessuna richiesta parte con la pagina vecchia.
  const [storedPage, setStoredPage] = useState({ search: '', page: 1 })
  const pageOfSearch = storedPage.search === search ? storedPage : { search, page: 1 }
  if (pageOfSearch !== storedPage) setStoredPage(pageOfSearch)
  const { page } = pageOfSearch

  const { data, isFetching, isError } = useContacts(
    page,
    SEGMENT_CONTACTS_PAGE_SIZE,
    search ? { segmentId, search } : { segmentId },
    { enabled, keepPreviousPage: true },
  )

  return {
    searchInput,
    setSearchInput,
    page,
    setPage: (nextPage: number) => setStoredPage({ search, page: nextPage }),
    contacts: data?.items ?? [],
    totalPages: data?.pages ?? 1,
    isFetching,
    isError,
    reset: () => {
      setSearchInput('')
      setStoredPage({ search: '', page: 1 })
    },
  }
}

export type SegmentContactSearch = ReturnType<typeof useSegmentContactSearch>
